import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-add-material-charge',
  templateUrl: './add-material-charge.component.html',
  styleUrls: ['./add-material-charge.component.css']
})
export class AddMaterialChargeComponent implements OnInit {

  cid:any;
  form: any | FormGroup;
  addButton = false;
  formSubmitted = false;
  uomData:any = []

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.form = this.fb.group({
      chargeName: ['',[Validators.required]],
      description: [''],
      uom: [''],
      qty: [''],
      price: ['']
    })

    this.getAllUomMaster()
  }


  addMaterialCharge(){
    this.formSubmitted = true;
    if(!this.form.valid){
      console.log(this.form.value)
      return
    }
    this.addButton = true;

    let body = {
        "version": 0,
        "isActive": true,
        "description": String(this.form.get('description').value),
        "id": "",
        "materialChargeId": 0,
        "chargeName": String(this.form.get('chargeName').value),
        "uom": String(this.form.get('uom').value),
        "qty": Number(this.form.get('qty').value),
        "price": Number(this.form.get('price').value),
        "cid": Number(this.cid)
    }
    console.log(body)
    this.generic_service.addMaterialCharge(body).subscribe(
      (response:any) => {
        console.log(response)
        this.form.reset()
        this.toastr.success(response.message)
        this.addButton = false;
        this.formSubmitted = false;
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
        this.addButton = false;
      }
    )
  }


  getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (res:any)=> {
        console.log(res)
        this.uomData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

}
